<canvas
  #canvas
  baseChart
  [data]="chartData()"
  [options]="chartOptions()"
  [type]="'line'"
  [plugins]="plugins"
></canvas>
